import { render } from "./Welcome.vue?vue&type=template&id=27e2ef7a&scoped=true&ts=true"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"

import "./Welcome.vue?vue&type=style&index=0&id=27e2ef7a&scoped=true&lang=css"

import exportComponent from "/home/alex/IdeaProjects/celine-coach-bien-etre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e2ef7a"]])

export default __exports__